import { useMutation } from '@tanstack/react-query';

import {
    postCreditCardWaitlist,
    PostWaitlistRequestBody
} from './creditCardWaitlistApi';
import { useStateKey } from '../../../../../iwQueryClient/useStateKey';

type UseCreditCardWaitlistProps = PostWaitlistRequestBody['data'];

export const useCreditCardWaitlist = () => {
    const stateKey = useStateKey();

    return useMutation({
        mutationFn: (props: UseCreditCardWaitlistProps) =>
            postCreditCardWaitlist(stateKey, { data: props })
    });
};
